import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-kyc-page',
  templateUrl: './kyc-page.component.html',
  styleUrls: ['./kyc-page.component.scss']
})
export class KycPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
